















import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({})
export default class IconButton extends Vue {
  @Prop({required: true, type: String, default: ''})
  tooltip!: string;

  @Prop({required: false, type: Boolean, default: false})
  disabled!: boolean;

  @Prop({default: () => ({})})
  activators!: {};
}
